function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M11.9997 8.72729C13.8052 8.72729 15.2725 10.1946 15.2725 12C15.2725 13.8055 13.8052 15.2727 11.9997 15.2727C10.1943 15.2727 8.72701 13.8055 8.72701 12C8.72701 10.1946 10.1943 8.72729 11.9997 8.72729Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 3.81812C17.4545 3.81812 22.1127 7.21081 24 11.9999C22.1127 16.789 17.4545 20.1818 12 20.1818C6.53999 20.1818 1.88724 16.789 -5.21776e-05 11.9999C1.88724 7.21081 6.53999 3.81812 12 3.81812ZM12 17.4545C15.0109 17.4545 17.4545 15.0108 17.4545 11.9999C17.4545 8.98898 15.0109 6.54537 12 6.54537C8.98906 6.54537 6.54541 8.98903 6.54541 11.9999C6.54541 15.0108 8.98906 17.4545 12 17.4545Z"
}));

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.84ea1a6a.svg";
export { ForwardRef as ReactComponent };